import React, { useState, useEffect } from 'react'
import "./Dashboard.css"
import Calendar from '../Calendar/Calendar.jsx'
import Sidebar from '../Sidebar/Sidebar'
import AdminNavbar from '../AdminNavbar/AdminNavbar'
// import joinnow from "../../Image/joinnow.png"
// import { Pie, Doughnut } from "react-chartjs-2";
// import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
const apiUrl = process.env.REACT_APP_API_BASE_URL;


function Dashboard() {






    const [inquiryData, setInquiryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);


    const [studentsCount, setStudentsCount] = useState(0);
    const [mentorsCount, setMentorsCount] = useState(0);
    const [coursesCount, setCoursesCount] = useState(0);

    useEffect(() => {
        fetch(`${apiUrl}/api/auth/applications`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch inquiries");
                }
                return response.json();
            })
            .then((data) => {
                setInquiryData(data.applications.reverse());
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });


        fetch(`${apiUrl}/api/auth/stats`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to fetch stats");
                }
                return response.json();
            })
            .then(stats => {
                setStudentsCount(stats.students);
                setMentorsCount(stats.mentors);
                setCoursesCount(stats.courses);
            })
            .catch(error => console.error("Error fetching stats:", error));
    }, []);


    const [monthlyData, setMonthlyData] = useState([]);

    useEffect(() => {
        fetch(`${apiUrl}/api/auth/applications/monthly`)
            .then(response => response.json())
            .then(data => {
                console.log("API Response:", data);
                setMonthlyData(data);
            })
            .catch(error => console.error("Error fetching data:", error));
    }, []);

    const popularClassData = [
        { label: "Design", percentage: 20, color: "#4CAF50" },
        { label: "Programming", percentage: 40, color: "#FF9800" },
        { label: "Data Science", percentage: 40, color: "#2196F3" }
    ];


    const maxCount = Math.max(...monthlyData.map(item => item.count), 1); 


    return (
        <>
            <div class='main-dashboard'>
                <div>
                    <Sidebar />
                </div>

                <div className="dashboard">
                    <AdminNavbar />

                    <div className="content">
                        <div className="main-content">
                            <div className="info-cards">
                                <div className="info-card course-card">
                                    <div className="card-text">
                                        <h3>Certified Online Courses For Students</h3>
                                        <div className="certificate-icons">
                                            <span className="certificate-icon">🏆</span>
                                            <span className="certificate-icon">📜</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{coursesCount}+</h3>
                                        <p>Courses</p>
                                    </div>
                                    <div className="card-icon purple">
                                        <span>📚</span>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{studentsCount}+</h3>
                                        <p>Students</p>
                                    </div>
                                    <div className="card-icon blue">
                                        <span>👨‍🎓</span>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{mentorsCount}+</h3>
                                        <p>Mentors</p>
                                    </div>
                                    <div className="card-icon purple">
                                        <span>👨‍🏫</span>
                                    </div>
                                </div>
                            </div>
                            <div className="statistics-container">
                                <div className="statistics-headers">
                                    <h3>Project Statistics</h3>
                                    <div className="dropdown">
                                        <span>Month</span>
                                    </div>
                                </div>

                                <div className="chart">
                                    {monthlyData.length > 0 ? (
                                        monthlyData.map((item, index) => (
                                            <div key={index} className="chart-column">
                                                <div className="chart-bar-container">
                                                    <div className="chart-bar" style={{ height: "90px" }}>
                                                        <span
                                                            className="count-label"
                                                            style={{ bottom: `${(item.count / maxCount) * 100 + 10}px` }}
                                                        >
                                                            {item.count}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="chart-label">{item.month}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No data available</p>
                                    )}
                                </div>
                            </div>


                            <div className="tables-container">
                                <div className="inquiry-table">
                                    <h3>Inquiry</h3>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>contact No</th>
                                                <th>interest</th>
                                                <th>education</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {inquiryData.length === 0 ? (
                                                <tr>
                                                    <td colSpan="8">No inquiries found.</td>
                                                </tr>
                                            ) : (
                                                inquiryData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{row.name}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.contactNumber}</td>

                                                        <td>{row.interest}</td>
                                                        <td>{row.education}</td>


                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="popular-class">
                                    <h3>Popular Class</h3>
                                    <div className="pie-chart-container">
                                        <div className="pie-chart">
                                            <svg width="150" height="150" viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" r="40" className="pie-chart-circle"
                                                    style={{
                                                        strokeDasharray: `${popularClassData[0].percentage} ${100 - popularClassData[0].percentage}`,
                                                        stroke: popularClassData[0].color,
                                                        strokeDashoffset: "25"
                                                    }} />
                                                <circle cx="50" cy="50" r="40" className="pie-chart-circle"
                                                    style={{
                                                        strokeDasharray: `${popularClassData[1].percentage} ${100 - popularClassData[1].percentage}`,
                                                        stroke: popularClassData[1].color,
                                                        strokeDashoffset: `${100 - popularClassData[0].percentage + 25}`
                                                    }} />
                                                <circle cx="50" cy="50" r="40" className="pie-chart-circle"
                                                    style={{
                                                        strokeDasharray: `${popularClassData[2].percentage} ${100 - popularClassData[2].percentage}`,
                                                        stroke: popularClassData[2].color,
                                                        strokeDashoffset: `${100 - popularClassData[0].percentage - popularClassData[1].percentage + 25}`
                                                    }} />
                                            </svg>
                                            <div className="pie-chart-center">
                                                <div>
                                                    <div className="percentage">40</div>
                                                    <div className="percentage-label">49.5%</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pie-chart-legend">
                                            {popularClassData.map((item, index) => (
                                                <div key={index} className="legend-item">
                                                    <div className="legend-color" style={{ backgroundColor: item.color }}></div>
                                                    <div className="legend-label">{item.label}</div>
                                                    <div className="legend-value">{item.percentage}%</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <Calendar />
                    </div>
                </div>
            </div>


        </>
    )
}

export default Dashboard
